import script from "./LightControllersSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LightControllersSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./LightControllersSettingPage.vue?vue&type=style&index=0&id=078ca0a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-078ca0a8"]])

export default __exports__